<template>
	<div class="mt-4">
		<div class="filter-bar flex justify-center mt-2 mb-4">
			<button
				:class="{'mgs-selected-button': typeMode === 'scores'}"
				@click="typeMode = 'scores'"
				class="mgs-button button is-small mx-1"
				:key="`round-stat-scoring-scores`"
			>SCORING</button>
			<button
				:class="{'mgs-selected-button': typeMode === 'driving'}"
				@click="typeMode = 'driving'"
				class="mgs-button button is-small mx-1"
				:key="`round-stat-scoring-driving`"
			>DRIVING</button>
			<button
				:class="{'mgs-selected-button': typeMode === 'gir'}"
				@click="typeMode = 'gir'"
				class="mgs-button button is-small mx-1"
				:key="`round-stat-scoring-gir`"
			>GIR</button>
			<button
				:class="{'mgs-selected-button': typeMode === 'putting'}"
				@click="typeMode = 'putting'"
				class="mgs-button button is-small mx-1"
				:key="`round-stat-scoring-putting`"
			>PUTTING</button>
			<button
				:class="{'mgs-selected-button': typeMode === 'scrambling'}"
				@click="typeMode = 'scrambling'"
				class="mgs-button button is-small mx-1"
				:key="`round-stat-scoring-scrambling`"
			>SCRAMBLING</button>
		</div>
		<round-statistic-container class="mb-4" title="Scoring" v-if="typeMode === 'scores'">
			<statistics-scoring :round-scoring="golfRound.total_scoring"></statistics-scoring>
		</round-statistic-container>
		<round-statistic-container class="mb-4" title="Fairways" v-if="typeMode === 'driving'">
			<statistics-fairways :round-fairways="golfRound.total_driving"></statistics-fairways>
		</round-statistic-container>
		<round-statistic-container class="mb-4" title="GIR" v-if="typeMode === 'gir'">
			<statistics-greens :round-greens="golfRound.total_gir"></statistics-greens>
		</round-statistic-container>
		<round-statistic-container class="mb-4" title="Putting" v-if="typeMode === 'putting'">
			<statistics-putts :round-putts="golfRound.total_putting"></statistics-putts>
		</round-statistic-container>
		<round-statistic-container class="mb-4" title="Scrambling" v-if="typeMode === 'scrambling'">
			<statistics-scrambling :round-scrambling="golfRound.total_scrambling"></statistics-scrambling>
		</round-statistic-container>
	</div>
</template>
<script>
/** @format */

export default {
	name: 'GolfScoreGraphic',
	props: {
		golfRound: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			typeMode: 'scores'
		}
	},
	components: {
		'round-statistic-container': () => import(/* webpackChunkName: "RoundStatisticContainer" */ './Statistic/Container'),
		'statistics-fairways': () => import(/* webpackChunkName: "StatisticsFairways" */ './../Statistics/Fairways'),
		'statistics-greens': () => import(/* webpackChunkName: "StatisticsGreens" */ './../Statistics/Greens'),
		'statistics-putts': () => import(/* webpackChunkName: "StatisticsPutts" */ './../Statistics/Putts'),
		'statistics-scoring': () => import(/* webpackChunkName: "StatisticsScoring" */ './../Statistics/Scoring'),
		'statistics-scrambling': () => import(/* webpackChunkName: "StatisticsScrambling" */ './../Statistics/Scrambling')
	}
};
</script>
<style lang="scss" scoped>
.stat-title {
	font-size: 1.5rem;
}
</style>
